import { LanguageRecord } from '@/graphql/types'
import { Button, cn } from '@desoutter/uikit'
import { X } from 'lucide-react'

type SearchInputProps = {
	input: React.RefObject<HTMLInputElement>
	localQuery: string
	setLocalQuery: (query: string) => void
	translations: Partial<LanguageRecord>
	containerClassName?: string
	className?: string
	isModal?: boolean
}

export default function SearchInput({
	input,
	localQuery,
	setLocalQuery,
	translations,
	containerClassName,
	className,
	isModal,
}: SearchInputProps) {
	const clearInput = () => setLocalQuery('')
	return (
		<div className={cn('relative flex-grow w-full', containerClassName)}>
			<input
				ref={input}
				type="text"
				value={localQuery}
				onChange={(e) => setLocalQuery(e.target.value)}
				className={cn(
					'w-full rounded-full bg-gray-50 focus-visible:outline-none text-gray-900 pr-16',
					className,
				)}
				placeholder={translations.searchPlaceholer}
				name={translations.searchPlaceholer}
			/>
			{localQuery && (
				<div
					onClick={clearInput}
					className={cn(
						'border border-gray-200 rounded-full absolute right-0 top-0 mr-1 mt-1 h-[calc(100%-0.5rem)] flex items-center justify-center cursor-pointer aspect-square',
						{
							'h-[calc(100%-1rem)] mt-2 mr-2': !isModal,
						},
					)}
				>
					<X className="w-8 h-8" strokeWidth={1.5} />
				</div>
			)}
		</div>
	)
}
